import { Box, Grid, Stack } from '@mui/material';
import NumberWidget from 'components/Widgets/NumberWidget';
import ChartWidget from 'components/Widgets/ChartWidget';
import '../DataEstate/data-estate-dashboard.scss';
import { useEffect, useState } from 'react';
import {
	fetchAnnualSpendDataSourceIncidents,
	fetchDataProcessingTrends,
	fetchDataprocessingSummaryKpi,
	fetchPerformanceData,
	getDBDatabricks,
	dataProcessingTable,
	fetchDatabricksClustersCount,
	fetchDataprocessingSynapse,
	getDataEstateKpiSector,
	getDataEstateSector
} from '../../service/service';
import moment from 'moment';
import { getPercentageOfTwoNumbers } from '../../utils/common-util';
import '../DataEstate/data-estate.scss';
import { CustomizedDataGrid } from '../customized_data_grid';
import { Row, type Column } from 'react-data-grid';
import { isEnvTypePROD } from '../../service/config';
import PageHeader from 'components/Header/Page';
import { useCacheDataController } from 'Context/contexts/CacheDataContext';
import DataProcIcon from '../../assets/data-processing.svg';
import WidgetCardContainer from 'components/Widgets/WidgetCardContainer';
import GuageWidget from 'components/Widgets/GaugeWidget';
import MultiLineWidget from 'components/Widgets/MultiLineChart';
import SingleSelectFilter from 'components/Dropdown/SingleSelectFilter';
import { sectorListDetails } from 'Context/contexts/cacheData/DataEstate/type';
import PageWrapper from 'components/Common/PageWraper';
import HighlightedText from 'components/GlobalSearch/HighlightText';
import { renderTooltipIcon } from 'components/TableauObs/common/KpiCard';
import { useHeader } from 'Context/contexts/HeaderTabRightContentContext';

function formatNumber(number: any) {
	if (number != null && !isNaN(number)) {
		return Number(number).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	} else {
		return '0.00';
	}
}
export default function DataProcessingSummary() {
	const { setRightContextContent } = useHeader();
	const [controller] = useCacheDataController();
	const { teradataStorageLastSyncDate } = controller;
	const [ADFPipeline, SetADFPipeline] = useState(0);
	const [azureSqlUptime, SetAzureSqlUptime] = useState({});
	const [synapseUptime, SetSynapseUptime] = useState({})
	const [teradataJobs, SetTeradataJobs] = useState(0);

	const [databricksClusters, SetDatabricksClusters] = useState('-');
	const [, SetDatabricksClustersLastExecution] = useState(0);
	const [, SetDatabricksClustersCurrent] = useState(0);
	const [, SetDatabricksJobExecutionTimeLoader] = useState(true);
	const [, SetDatabricksJobExecutionTimeChartOptions] = useState({});
	const [teradataJobExecutionTimeLoader, SetTeradataJobExecutionTimeLoader] = useState(true);
	const [azureUptimeLoader, SetAzureUptimeLoader] = useState(true);
	const [synapseUptimeLoader, SetSynapseUptimeLoader] = useState(true);
	const [teradataJobExecutionTimeChartOptions, SetSetTeradataJobExecutionTimeChartOptions] = useState({});
	const [performanceDBJobExecutionTimeLoader, setPerformanceDBJobExecutionTimeLoader] = useState(true);
	const [performanceDBJobExecutionTimeChartOptions, setPerformanceDBJobExecutionTimeChartOptions] = useState({});

	const [pipelineGrowthLoading, setPipelineGrowthLoading] = useState(true);
	const [pipelineGrowthOptions, setPipelineGrowthOptions] = useState<any>();
	const [clusterGrowthLoading, setClusterGrowthLoading] = useState(true);
	const [clusterGrowthOptions, setClusterGrowthOptions] = useState<any>();
	const [teradataJobsLoading, setTeradataJobsLoading] = useState(true);
	const [teradataJobsOptions, setTeradataJobsOptions] = useState<any>();

	const [lastUpdatedDatePipeline, setLastUpdatedDatePipeline] = useState('');
	const [lastUpdatedDateCluster, setLastUpdatedDateCluster] = useState('');
	const [lastUpdatedDateTeradata, setLastUpdatedDateTeradata] = useState('');

	// sector filter
	const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
	const [sector] = useState<any[]>([]);
	const [filterMonth] = useState('0M');
	const [, setLoading] = useState(false);
	// server filter
	const [, SetDatabricksBubbleValue] = useState(0);

	let dimension: any = '';
	const [customMonth] = useState('');
	const [sectorName, setSectorName] = useState('all');

	const [allSectorOptionsList, setAllSectorOptionsList] = useState<sectorListDetails | null>(null);
	const [sectorTagList, setSectorTagList] = useState<any>({ datapipeline: true, uptime: true });

	const [allSectorADFPipelineData] = useState(() => {
		try {
			const sectorData = localStorage.getItem('adfPipelineDetails');
			if (!sectorData || sectorData === 'undefined' || sectorData === 'null') {
				return null;
			}
			return JSON.parse(sectorData);
		} catch (error) {
			return null;
		}
	});

	async function fetchSectorOptionsData() {
		let sectorKpi = [];
		sectorKpi.push("datapipeline", "uptime");
		const sectorRes = await getDataEstateKpiSector(sectorKpi);
		if (sectorRes.success) {
			if (sectorRes.data) {
				setAllSectorOptionsList(sectorRes.data);
			}
		}
		const sectorKpiRes = await getDataEstateSector();
		if (sectorKpiRes.success) {
			if (sectorKpiRes.data) {
				const sectorValues = sectorKpiRes.data.map((item: { sector: any; }) => item.sector);
				const uniqueSectors = Array.from(new Set(sectorValues));
				const sectorNameList: string[] = uniqueSectors.map(sector =>
					(sector === "" || sector === null || sector === undefined) ? "Blank" : String(sector)
				);
				const sortedSectors = [...sectorNameList].sort((a: string, b: string) => a.localeCompare(b));
				setSectorOptionsList(sortedSectors);
			}
		}
	}

	async function getDataProcessingSynapseTime(selectedDate?: string, sectors?: any, from?: string) {
		setLoading(true);
		SetSynapseUptimeLoader(true);
		try {
			const res = await fetchDataprocessingSynapse(selectedDate, sectors);
			console.log(res);

			if (res?.data) {
				let SynapseUptimeOption = {
					backgroundColor: 'transparent',
					series: [
						{
							type: 'gauge',
							center: ['50%', '55%'],
							min: 0,
							max: 100,
							splitNumber: 5,
							itemStyle: {
								color: '#009BD8'
							},
							progress: {
								show: true,
								width: 16
							},
							pointer: {
								show: false
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 16,
									color: [
										[1, '#EFF2F7']
									]
								}
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false
							},
							axisLabel: {
								show: false
							},
							detail: {
								valueAnimation: true,
								width: '60%',
								offsetCenter: [0, '-10%'],
								formatter: function (value: number) {
									return '{title|Uptime}\n{value|' + (value ? value.toFixed(2) : '0.00') + '%}';
								},
								rich: {
									title: {
										fontSize: 13,
										color: '#71758F',
										fontWeight: 500,
										lineHeight: 22,
										align: 'center'
									},
									value: {
										fontSize: 24,
										fontWeight: 700,
										color: '#001E3E',
										lineHeight: 32,
										align: 'center'
									}
								}
							},
							data: [
								{
									value: res?.data?.synapseUptimeCount
								}
							]
						}
					]
				};
				SetSynapseUptime(SynapseUptimeOption);
			} else {
				SetSynapseUptime({});
			}
		} catch (error) {
			console.error(error);
			SetSynapseUptime({});
		} finally {
			setLoading(false);
			SetSynapseUptimeLoader(false);
		}
	}

	async function getDataProcessingSummary(selectedDate?: string, sectors?: any, from?: string) {
		setLoading(true);
		if (from == "") {
			SetDatabricksJobExecutionTimeLoader(true);
			SetTeradataJobExecutionTimeLoader(true);
			SetAzureUptimeLoader(true);
		}
		const todaysDate = moment().utc().format('YYYY-MM-DD');
		fetchDataprocessingSummaryKpi(selectedDate, sectors)
			.then((res) => {
				SetADFPipeline(res?.data?.dataPipelineCount);
				if (sectors == 'all' && res?.data?.dataPipelineCount !== undefined) {
					localStorage.setItem('adfPipelineDetails', JSON.stringify(res.data.dataPipelineCount));
				}
				setLoading(false);
				if (from == "") {
					if (res?.data?.azureSqlUptimeCount?.[0]?.VALUE) {
						let AzureSQLUptimeOption = {
							backgroundColor: 'transparent',
							series: [
								{
									type: 'gauge',
									center: ['50%', '55%'],
									min: 0,
									max: 100,
									splitNumber: 5,
									itemStyle: {
										color: '#009BD8'
									},
									progress: {
										show: true,
										width: 16
									},
									pointer: {
										show: false
									},
									axisLine: {
										show: true,
										lineStyle: {
											width: 16,
											color: [
												[1, '#EFF2F7']
											]
										}
									},
									axisTick: {
										show: false
									},
									splitLine: {
										show: false
									},
									axisLabel: {
										show: false
									},
									detail: {
										valueAnimation: true,
										width: '60%',
										offsetCenter: [0, '-10%'],
										formatter: function (value: number) {
											return '{title|Uptime}\n{value|' + (value ? value.toFixed(2) : '0.00') + '%}';
										},
										rich: {
											title: {
												fontSize: 13,
												color: '#71758F',
												fontWeight: 500,
												lineHeight: 22,
												align: 'center'
											},
											value: {
												fontSize: 24,
												fontWeight: 700,
												color: '#001E3E',
												lineHeight: 32,
												align: 'center'
											}
										}
									},
									data: [
										{
											value: res?.data?.azureSqlUptimeCount[0]?.VALUE
										}
									]
								}
							]
						};
						SetAzureSqlUptime(AzureSQLUptimeOption);
					} else {
						SetAzureSqlUptime({});
					}
					SetAzureUptimeLoader(false);
				}
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
				if (from == "") {
					SetAzureSqlUptime({});
					SetAzureUptimeLoader(false);
				}
			});
		if (from == "") {
			fetchAnnualSpendDataSourceIncidents('teradata-jobs', selectedDate, sectors)
				.then((res) => {
					SetTeradataJobs(res?.data?.result[0]?.count);
				})
				.catch((error) => {
					console.error(error);
				});
			fetchPerformanceData('databricks', selectedDate, sectors)
				.then((res) => {
					setPerformanceDBJobExecutionTimeLoader(false);

					if (res?.data?.interactiveCluster && res?.data?.jobCluster && res?.data?.warehouse && res?.data?.avgMedian) {
						const interactiveClusterData = res.data.interactiveCluster;
						const jobClusterData = res.data.jobCluster;
						const warehouseData = res.data.warehouse;
						const avgMedianData = res.data.avgMedian;

						const interactiveCluster = interactiveClusterData.map((item: { Median: any }) => item.Median / 3600);
						const DBWarehouseData = warehouseData.map((item: { Median: any }) => item.Median / 3600);
						const DBjobClusterData = jobClusterData.map((item: { Median: any }) => item.Median / 3600);
						const DBavgMedianData = avgMedianData.map((item: { avgMedian: any; Median: any }) => item.avgMedian / 3600);

						const dates = interactiveClusterData.map((item: { startDate: string | number | Date }) => {
							const date = new Date(item.startDate);
							return `${date.getDate()} ${date.toLocaleString('default', { month: 'short' })}`;
						});
						const dataBricksChartData = {
							backgroundColor: 'transparent',
							tooltip: {
								trigger: 'axis',
								textStyle: {
									color: '#001E3E',
									fontSize: 12
								},
								confine: true,
								backgroundColor: '#FFFFFF',
								borderColor: '#E2E8F0',
								borderWidth: 1,
								extraCssText: 'box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08); border-radius: 8px;',
								formatter: function (params: any[]) {
									let tooltipContent = '';
									const date = params[0]?.axisValueLabel;
									params.forEach((item) => {
										tooltipContent += `
									<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color};"></span><strong>${item.seriesName}</strong>: ${item.value.toFixed(2)}h</div>
									`;
									});
									return `<div style="font-weight:600;margin-bottom:4px;">Date: ${date}</div>` + tooltipContent;
								}
							},
							grid: {
								top: '10%',
								right: '3%',
								left: window.innerWidth < 600 ? '18%' : '12%',
								bottom: '18%'
							},
							xAxis: {
								type: 'category',
								boundaryGap: false,
								data: dates,
								axisLabel: {
									color: '#71758F',
									interval: 0,
									rotate: 25,
									fontSize: 11
								},
								axisLine: {
									lineStyle: {
										color: '#E2E8F0'
									}
								},
								splitLine: {
									show: true,
									lineStyle: {
										type: 'dashed',
										color: 'rgba(113, 117, 143, 0.15)',
										width: 1
									}
								}
							},
							yAxis: {
								type: 'value',
								name: 'Exec. Time',
								nameLocation: 'middle',
								nameGap: 35,
								nameTextStyle: {
									color: '#71758F',
									fontSize: 10,
									align: 'center'
								},
								min: 'dataMin',
								axisLabel: {
									color: '#71758F',
									fontSize: window.innerWidth < 600 ? 11 : 12,
									margin: 8,
									rotate: window.innerWidth < 600 ? 30 : 0,
									formatter: function (value: number) {
										if (value < 1) {
											return `${(value * 60).toFixed(0)}m`;
										}
										return value >= 1000 ? `${value / 1000}k h` : `${value}h`;
									}
								},
								splitLine: {
									show: true,
									lineStyle: {
										type: 'dashed',
										color: 'rgba(113, 117, 143, 0.15)',
										width: 1
									}
								}
							},
							series: [
								{
									name: 'Interactive Cluster',
									type: 'line',
									data: interactiveCluster,
									color: 'rgba(24, 165, 80, 1)'
								},
								{
									name: 'SQL Warehouse',
									type: 'line',
									data: DBWarehouseData,
									color: 'rgba(253, 120, 59, 1)'
								},
								{
									name: 'Job Cluster',
									type: 'line',
									data: DBjobClusterData,
									color: 'rgba(41, 155, 235, 1)'
								},
								{
									name: 'Databricks Avg Execution',
									type: 'line',
									data: DBavgMedianData,
									color: 'rgba(236, 48, 87, 1)'
								}
							],
							legend: {
								type: 'scroll',
								pageIconColor: '#71758F',
								pageIconInactiveColor: '#CBD5E1',
								pageTextStyle: {
									color: '#71758F',
									fontSize: 10
								},
								pageButtonItemGap: 5,
								pageButtonGap: 10,
								orient: 'horizontal',
								bottom: '0%',
								left: 'center',
								textStyle: {
									color: '#555555',
									fontSize: 11
								},
								selectedMode: false,
								itemWidth: 10,
								itemHeight: 10,
								icon: 'roundRect'
							}
						};

						setPerformanceDBJobExecutionTimeChartOptions(dataBricksChartData);
					} else {
						setPerformanceDBJobExecutionTimeChartOptions({});
					}
				})
				.catch((error) => {
					console.error(error);
					setPerformanceDBJobExecutionTimeChartOptions({});
				})
				.finally(() => {
					setPerformanceDBJobExecutionTimeLoader(false);
				});

			fetchPerformanceData('teradata', selectedDate, sectors)
				.then((resp) => {
					if (resp?.data?.controlm && resp?.data?.autosys && resp?.data?.teradataAvg) {
						const controlMData = resp.data.controlm;
						const autosysData = resp.data.autosys;
						const teradataavgexeData = resp.data.teradataAvg;

						const ControlM = controlMData.map((item: { exec_in_sec: any }) => item.exec_in_sec / 3600);
						const Autosys = autosysData.map((item: { exec_in_sec: any }) => item.exec_in_sec / 3600);
						const TeraDataAvgExe = teradataavgexeData.map((item: { avg_exec_in_sec: any }) => item.avg_exec_in_sec / 3600);

						const dates = controlMData.map((item: { date: string | number | Date }) => {
							const date = new Date(item.date);
							return `${date.getDate()} ${date.toLocaleString('default', { month: 'short' })}`;
						});
						const teradataOption = {
							backgroundColor: 'transparent',
							tooltip: {
								trigger: 'axis',
								textStyle: {
									color: '#001E3E',
									fontSize: 12
								},
								confine: true,
								backgroundColor: '#FFFFFF',
								borderColor: '#E2E8F0',
								borderWidth: 1,
								extraCssText: 'box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08); border-radius: 8px;',
								formatter: function (params: any[]) {
									let tooltipContent = '';
									const date = params[0]?.axisValueLabel;
									params.forEach((item) => {
										tooltipContent += `
									<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color};"></span><strong>${item.seriesName}</strong>: ${item.value.toFixed(2)}h</div>
									`;
									});
									return `<div style="font-weight:600;margin-bottom:4px;">Date: ${date}</div>` + tooltipContent;
								}
							},
							grid: {
								top: '10%',
								right: '3%',
								left: window.innerWidth < 600 ? '18%' : '12%',
								bottom: '18%'
							},
							xAxis: {
								type: 'category',
								boundaryGap: false,
								data: dates,
								axisLabel: {
									color: '#71758F',
									interval: 0,
									rotate: 25,
									fontSize: 11
								},
								axisLine: {
									lineStyle: {
										color: '#E2E8F0'
									}
								},
								splitLine: {
									show: true,
									lineStyle: {
										type: 'dashed',
										color: 'rgba(113, 117, 143, 0.15)',
										width: 1
									}
								}
							},
							yAxis: {
								type: 'value',
								name: 'Exec. Time',
								nameLocation: 'middle',
								nameGap: window.innerWidth < 600 ? 35 : 40,
								nameTextStyle: {
									color: '#71758F',
									fontSize: 10,
									align: 'center'
								},
								min: 'dataMin',
								axisLabel: {
									color: '#71758F',
									fontSize: window.innerWidth < 600 ? 11 : 12,
									margin: 8,
									rotate: window.innerWidth < 600 ? 30 : 0,
									formatter: function (value: number) {
										if (value < 1) {
											return `${(value * 60).toFixed(0)}m`;
										}
										return value >= 1000 ? `${value / 1000}k h` : `${value}h`;
									}
								},
								splitLine: {
									show: true,
									lineStyle: {
										type: 'dashed',
										color: 'rgba(113, 117, 143, 0.15)',
										width: 1
									}
								}
							},
							series: [
								{
									name: 'Control M',
									type: 'line',
									data: ControlM,
									color: 'rgba(24, 165, 80, 1)'
								},
								{
									name: 'Autosys',
									type: 'line',
									data: Autosys,
									color: 'rgba(41, 155, 235, 1)'
								},
								{
									name: 'Teradata Avg Exe.',
									type: 'line',
									data: TeraDataAvgExe,
									color: 'rgba(236, 48, 87, 1)'
								}
							],
							legend: {
								type: 'scroll',
								pageIconColor: '#71758F',
								pageIconInactiveColor: '#CBD5E1',
								pageTextStyle: {
									color: '#71758F',
									fontSize: 10
								},
								pageButtonItemGap: 5,
								pageButtonGap: 10,
								orient: 'horizontal',
								bottom: '0%',
								left: 'center',
								textStyle: {
									color: '#555555',
									fontSize: 11
								},
								selectedMode: false,
								itemWidth: 10,
								itemHeight: 10,
								icon: 'roundRect'
							}
						};

						SetSetTeradataJobExecutionTimeChartOptions(teradataOption);
					} else {
						SetSetTeradataJobExecutionTimeChartOptions({});
					}
				})
				.catch((error) => {
					console.error(error);
					SetSetTeradataJobExecutionTimeChartOptions({});
				})
				.finally(() => {
					SetTeradataJobExecutionTimeLoader(false);
				});
		}
		fetchDataProcessingTrends('adfpipelinegrowth', selectedDate, sectors)
			.then((res) => {
				if (res?.data?.data) {
					setPipelineGrowthOptions(res.data.data);
					setLastUpdatedDatePipeline(res?.data.lastUpdatedDate ? res.data.lastUpdatedDate : todaysDate);
				} else {
					setPipelineGrowthOptions({});
				}
			})
			.catch((error) => {
				console.error(error);
				setPipelineGrowthOptions({});
			})
			.finally(() => {
				setPipelineGrowthLoading(false);
			});

		if (from == "") {
			fetchDataProcessingTrends('teradataJobsgrowth', selectedDate, sectors)
				.then((res) => {
					if (res?.data?.data) {
						setTeradataJobsOptions(res.data.data);
						setLastUpdatedDateTeradata(res?.data.lastUpdatedDate ? res.data.lastUpdatedDate : todaysDate);
					} else {
						setTeradataJobsOptions({});
					}
				})
				.catch((error) => {
					console.error(error);
					setTeradataJobsOptions({});
				})
				.finally(() => {
					setTeradataJobsLoading(false);
				});
		}

		// Databricks Cluster
		fetchDataProcessingTrends('clustergrowth', selectedDate, sectors)
			.then((res) => {
				if (res?.data?.data) {
					setClusterGrowthOptions(res.data.data);
					setLastUpdatedDateCluster(res?.data.lastUpdatedDate ? res.data.lastUpdatedDate : todaysDate);
				} else {
					setClusterGrowthOptions({});
				}
			})
			.catch((error) => {
				console.error(error);
				setClusterGrowthOptions({});
			})
			.finally(() => {
				setClusterGrowthLoading(false);
			});
	}

	// fetchPerformanceData('databricks', selectedDate, sector).then(res => {
	async function getDatabricksExecutionData(exeCount: number) {
		SetDatabricksJobExecutionTimeLoader(false);
		let databricksOption = {
			backgroundColor: '#003771',
			series: [
				{
					type: 'gauge',
					center: ['50%', '55%'],
					min: 0,
					max: Math.floor(exeCount * 1.1),
					splitNumber: 5,
					itemStyle: {
						color: '#e5e5e5'
					},
					progress: {
						show: false
					},
					pointer: {
						show: false
					},
					axisTick: {
						distance: -55,
						splitNumber: 8,
						lineStyle: {
							width: 0,
							color: '#999'
						}
					},
					splitLine: {
						distance: -30,
						length: 14,
						lineStyle: {
							width: 0,
							color: '#999'
						}
					},
					axisLabel: {
						distance: -35,
						color: '#999',
						fontSize: 14,
						formatter: (value: any) => {
							return Math.floor(value).toLocaleString();
						}
					},
					anchor: {
						show: false
					},
					title: {
						show: false
					},
					detail: {
						valueAnimation: true,
						width: '60%',
						lineHeight: 40,
						borderRadius: 8,
						offsetCenter: [0, 30],
						fontSize: 30,
						formatter: Math.floor(exeCount).toLocaleString(),
						color: '#e5e5e5'
					},
					data: [
						{
							value: Math.floor(exeCount)
						}
					]
				},
				{
					type: 'gauge',
					center: ['50%', '55%'],
					min: 0,
					max: Math.floor(exeCount * 1.1),
					itemStyle: {
						color: '#FD7347'
					},
					progress: {
						show: true,
						width: 10
					},
					pointer: {
						show: false
					},
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					splitLine: {
						show: false
					},
					axisLabel: {
						show: false
					},
					detail: {
						valueAnimation: true,
						width: '60%',
						lineHeight: 40,
						borderRadius: 8,
						offsetCenter: [0, '-30%'],
						fontSize: 14,
						fontWeight: 'normal',
						formatter: 'Avg Execution',
						color: '#e5e5e5'
					},
					data: [
						{
							value: exeCount
						}
					]
				}
			]
		};
		SetDatabricksJobExecutionTimeChartOptions(databricksOption);
	}

	async function loadDatabricksAnnualIndicator() {
		let startDate = moment().subtract(1, 'months').startOf('month').format('yyyy-MM-DD');
		let endDate = moment().subtract(1, 'months').endOf('month').format('yyyy-MM-DD');

		try {
			const res = await fetchDatabricksClustersCount(startDate, endDate, true);
			if (res.success) {
				if (res.data.databricksClustersCount.length) {
					let currentYearCount = res.data.databricksClustersCount.reduce(
						(count: any, item: any) => count + item.count,
						0
					);
					loadDatabricksLastYearData(currentYearCount);
					SetDatabricksClustersCurrent(currentYearCount);
				}
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	}

	async function loadDatabricksLastYearData(currentYearCount: number) {
		let lastyearStartDate = moment().subtract(1, 'year').subtract(1, 'months').startOf('month').format('yyyy-MM-DD');
		let lastYearEndDate = moment().subtract(1, 'year').subtract(1, 'months').format('yyyy-MM-DD');

		try {
			const res = await fetchDatabricksClustersCount(lastyearStartDate, lastYearEndDate, true);
			if (res.success) {
				if (res.data.databricksClustersCount.length) {
					let lastYearCount = res.data.databricksClustersCount.reduce((count: any, item: any) => count + item.count, 0);
					SetDatabricksClustersLastExecution(lastYearCount);
					SetDatabricksBubbleValue(getPercentageOfTwoNumbers(lastYearCount, currentYearCount));
				}
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	}

	async function loadDatabricksClustersCount(selectedDateFilter?: string) {
		let startDate: any;
		let endDate: any;
		if (selectedDateFilter === '0M') {
			startDate = moment().startOf('month').format('yyyy-MM-DD');
			endDate = moment().format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '1M') {
			startDate = moment().subtract(1, 'months').startOf('month').format('yyyy-MM-DD');
			endDate = moment().subtract(1, 'months').endOf('month').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '3M') {
			startDate = moment().subtract(2, 'months').startOf('month').format('yyyy-MM-DD');
			endDate = moment().endOf('month').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '6M') {
			startDate = moment().subtract(5, 'months').startOf('month').format('yyyy-MM-DD');
			endDate = moment().endOf('month').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '9M') {
			startDate = moment().subtract(8, 'months').startOf('month').format('yyyy-MM-DD');
			endDate = moment().endOf('month').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '0Y') {
			startDate = moment().subtract(0, 'year').startOf('year').format('yyyy-MM-DD');
			endDate = moment().endOf('year').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '1Y') {
			startDate = moment().subtract(1, 'year').startOf('year').format('yyyy-MM-DD');
			endDate = moment().subtract(1, 'year').endOf('year').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '2Y') {
			startDate = moment().subtract(1, 'year').startOf('year').format('yyyy-MM-DD');
			endDate = moment().endOf('year').format('yyyy-MM-DD');
		}
		setLoading(true);
		try {
			const res = await fetchDatabricksClustersCount(startDate, endDate, true, 'databricksCluster');
			if (res.success) {
				if (res.data.databricksClustersCount.length) {
					let count = res.data.databricksClustersCount.reduce((count: any, item: any) => count + item.count, 0);
					count = count / 1000000;
					SetDatabricksClusters(count.toFixed(2));
				} else {
					SetDatabricksClusters('-');
				}
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	}

	async function loadDatabricksClustersCountExecution(selectedDateFilter?: string) {
		let startDate: any;
		let endDate: any;
		if (selectedDateFilter === '0M') {
			startDate = moment().startOf('month').format('yyyy-MM-DD');
			endDate = moment().format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '1M') {
			startDate = moment().subtract(1, 'months').startOf('month').format('yyyy-MM-DD');
			endDate = moment().subtract(1, 'months').endOf('month').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '3M') {
			startDate = moment().subtract(2, 'months').startOf('month').format('yyyy-MM-DD');
			endDate = moment().endOf('month').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '6M') {
			startDate = moment().subtract(5, 'months').startOf('month').format('yyyy-MM-DD');
			endDate = moment().endOf('month').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '9M') {
			startDate = moment().subtract(8, 'months').startOf('month').format('yyyy-MM-DD');
			endDate = moment().endOf('month').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '0Y') {
			startDate = moment().subtract(0, 'year').startOf('year').format('yyyy-MM-DD');
			endDate = moment().endOf('year').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '1Y') {
			startDate = moment().subtract(1, 'year').startOf('year').format('yyyy-MM-DD');
			endDate = moment().subtract(1, 'year').endOf('year').format('yyyy-MM-DD');
		}
		if (selectedDateFilter === '2Y') {
			startDate = moment().subtract(1, 'year').startOf('year').format('yyyy-MM-DD');
			endDate = moment().endOf('year').format('yyyy-MM-DD');
		}
		setLoading(true);
		try {
			const res = await fetchDatabricksClustersCount(startDate, endDate);
			if (res?.success && res?.data?.databricksClustersCount?.length) {
				let sumOfExeCount = res.data.databricksClustersCount.reduce(
					(count: any, item: any) =>
						count + (item.jobSumOfRunTimeSec || 0) + (item.sqlSumOfRunTimeSec || 0) + (item.interactiveSumOfRunTimeSec || 0),
					0
				);
				let countOfExeCount = res.data.databricksClustersCount.reduce(
					(count: any, item: any) =>
						count + (item.jobCountOfRunTimeSec || 0) + (item.sqlCountOfRunTimeSec || 0) + (item.interactiveCountOfRunTimeSec || 0),
					0
				);
				let exeCount = countOfExeCount ? sumOfExeCount / countOfExeCount : 0;
				getDatabricksExecutionData(exeCount);
			} else {
				getDatabricksExecutionData(0);
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	}

	useEffect(() => {
		fetchSectorOptionsData();
		getDataProcessingSummary(filterMonth, sectorName, '');
		loadDatabricksClustersCount();
		loadDatabricksClustersCountExecution();
		loadDatabricksAnnualIndicator();
		getDataProcessingSynapseTime(filterMonth, sectorName, '');
	}, []);

	useEffect(() => {
		setRightContextContent(
			<Box sx={{ display: 'flex', alignItems: 'center', pr: 1 }}>
				<SingleSelectFilter
					sectorName={sectorName}
					setSectorName={setSectorName}
					sectorOptionsList={sectorOptionsList}
					handleChange={handleSectorChange}
					boxProps={{
						sx: {
							'& .MuiTypography-root': {
								display: 'none',
							},
						},
					}}
				/>
			</Box>
		);

		return () => {
			setRightContextContent(null);
		};
	}, [sectorName, sectorOptionsList]);
	interface ADF {
		azureSubscription: string;
		resourceGroup: string;
		pipelineName: string;
		pipelineStatus: string;
		runStart: string;
		runEnd: string;
		durationInMs: string;
		lastUpdated: string;
	}
	interface TeraDataJobs {
		jobName: string;
		boxName: string;
		sector: string;
		system: string;
		process: string;
		critical: string;
		lastSuccessfulRun: string;
		normalCompletionTime: string;
		observedSince: string;
	}
	interface DataBricks {
		workspace_name: string;
		cluster_name: string;
		cluster_category: string;
		total_dbus: string;
		project_name: string;
		job_name: string;
		timestamp_state_start: string;
		timestamp_state_end: string;
		sector_name: string;
	}
	interface Row { }
	function getColumns(): Array<Column<Row>> {
		if (typeName == 'ADF') {
			return [
				{
					key: 'azureSubscription',
					name: 'Azure Subscription',
					minWidth: 250
				},
				{
					key: 'resourceGroup',
					name: 'Resource Group',
					minWidth: 200
				},
				{
					key: 'pipelineName',
					name: 'Pipeline Name',
					minWidth: 200
				},
				{
					key: 'pipelineStatus',
					name: 'Pipeline Status',
					minWidth: 250
				},
				{
					key: 'runStart',
					name: 'Run Start',
					minWidth: 200
				},
				{
					key: 'runEnd',
					name: 'Run End',
					minWidth: 200
				},
				{
					key: 'durationInMs',
					name: 'Duration In MS',
					minWidth: 250
				},
				{
					key: 'lastUpdated',
					name: 'Last Updated',
					minWidth: 250
				}
			];
		} else if (typeName == 'TeraData') {
			return [
				{
					key: 'jobName',
					name: 'Job Name',
					minWidth: 180
				},
				{
					key: 'boxName',
					name: 'Box Name',
					minWidth: 180
				},
				{
					key: 'sector',
					name: 'Sector',
					minWidth: 170
				},
				{
					key: 'system',
					name: 'System',
					minWidth: 180
				},
				{
					key: 'process',
					name: 'Process',
					minWidth: 180
				},
				{
					key: 'critical',
					name: 'Critical',
					minWidth: 180
				},
				{
					key: 'lastSuccessfulRun',
					name: 'Last successful run',
					minWidth: 250
				},
				{
					key: 'normalCompletionTime',
					name: 'Normal completion Time',
					minWidth: 250
				},
				{
					key: 'observedSince',
					name: 'Observed since',
					minWidth: 250
				}
			];
		} else if (typeName == 'dataBricks') {
			return [
				{
					key: 'workspace_name',
					name: 'Project name',
					minWidth: 250
				},
				{
					key: 'cluster_name',
					name: 'Workspace',
					minWidth: 250
				},
				{
					key: 'cluster_category',
					name: 'Cluster name',
					minWidth: 250
				},
				{
					key: 'total_dbus',
					name: 'Job Name',
					minWidth: 250
				},
				{
					key: 'project_name',
					name: 'Job Run Time',
					minWidth: 250
				},
				{
					key: 'job_name',
					name: 'Job Status',
					minWidth: 250
				},
				{
					key: 'timestamp_state_start',
					name: 'Timestamp State Start',
					minWidth: 170
				},
				{
					key: 'timestamp_state_end',
					name: 'Timestamp State End',
					minWidth: 170
				},
				{
					key: 'sector_name',
					name: 'Start Time',
					minWidth: 170
				}
			];
		} else {
			return [];
		}
	}
	const ADFPipelinesColumns = [
		'Azure Subscription',
		'Resource Group',
		'Pipeline Name',
		'Pipeline Status',
		'Run Start',
		'Run End',
		'Duration In MS',
		'Last Updated'
	];
	const teraDataJobsColumns = [
		'Job Name',
		'Box Name',
		'Sector',
		'System',
		'Process',
		'Critical',
		'Last successful run',
		'Normal completion Time',
		'Observed since'
	];
	const dataBricksColumns = [
		'Project name',
		'Workspace',
		'Cluster name',
		'Job Name',
		'Job Run Time',
		'Job Status',
		'Timestamp State End',
		'Timestamp State End',
		'Start Time'
	];
	const [defaultColumnNames, setDynamicValue] = useState(['']);
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [isTableVisible, setIsTableVisible] = useState(false);

	const [tableData, setTableData] = useState<Row[]>([]);
	const [tableHeading, setTableHeading] = useState('');
	const [typeName, setTypeName] = useState('');

	async function processingListingFunc(pageNumber: any, size: any, sortingInfo: any) {
		let month = customMonth ? customMonth : filterMonth;
		const res = await dataProcessingTable('dataProcessing', dimension, sector, month);
		if (res.success) {
			setTableData(res.data.summary);
			if (res.data.page) {
				setPaginationData(res.data.page);
			}
			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);
		}
	}

	async function getDBDatabricksData(pageNumber: any, size: any, sortingInfo: any) {
		let startDate: any;
		let endDate: any;
		if (filterMonth === '0M') {
			startDate = moment();
			endDate = moment();
		}
		if (filterMonth === '1M') {
			startDate = moment().subtract(1, 'months').startOf('month');
			endDate = moment().endOf('month');
		}
		if (filterMonth === '3M') {
			startDate = moment().subtract(3, 'months').startOf('month');
			endDate = moment().endOf('month');
		}
		if (filterMonth === '6M') {
			startDate = moment().subtract(6, 'months').startOf('month');
			endDate = moment().endOf('month');
		}
		if (filterMonth === '9M') {
			startDate = moment().subtract(9, 'months').startOf('month');
			endDate = moment().endOf('month');
		}
		if (filterMonth === '0Y') {
			startDate = moment().subtract(0, 'year').startOf('year');
			endDate = moment().endOf('year');
		}
		if (filterMonth === '1Y') {
			startDate = moment().subtract(1, 'year').startOf('year');
			endDate = moment().endOf('year');
		}
		if (filterMonth === '2Y') {
			startDate = moment().subtract(2, 'year').startOf('year');
			endDate = moment().endOf('year');
		}
		let sector: any = [];
		let filterInfo: any = [];

		const res = await getDBDatabricks(pageNumber, size, sortingInfo, filterInfo, startDate, endDate, sector);

		if (res.success) {
			setTableData(res.data.result);
			if (res.data.page) {
				setPaginationData(res.data.page);
			}

			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);
		}
	}

	const handleSorting = (sortingInfo: any) => {
		processingListingFunc(page, pageSize, sortingInfo);
	};
	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		processingListingFunc(value, pageSize, sortingInfo);
	};
	const handlepageSizeChange = (event: any) => {
		processingListingFunc(page, event.target.value, sortingInfo);
	};
	const handleClick = (typeName: any) => {
		setDynamicValue([]);
		setTableData([]);
		setIsTableVisible(true);
		if (typeName == 'ADF') {
			console.log('default before', defaultColumnNames);
			setDynamicValue(ADFPipelinesColumns);
			setTableHeading('ADF Pipelines');
			type Row = keyof ADF;
			setTypeName('ADF');
			dimension = 'adfpipeline';
			console.log('default', defaultColumnNames);
			processingListingFunc(page, pageSize, sortingInfo);
		}
		if (typeName === 'Teradata') {
			console.log('default before', defaultColumnNames);
			setDynamicValue(teraDataJobsColumns);
			setTableHeading('TeraData Jobs');
			type Row = keyof TeraDataJobs;
			setTypeName('TeraData');
			dimension = 'teradataJobs';
			console.log('default', defaultColumnNames);
			processingListingFunc(page, pageSize, sortingInfo);
		}
		if (typeName === 'dataBricks') {
			console.log('default before', defaultColumnNames);
			setDynamicValue(dataBricksColumns);
			setTableHeading('Databricks clusters');
			type Row = keyof TeraDataJobs;
			setTypeName('dataBricks');
			console.log('default', defaultColumnNames);
			getDBDatabricksData(page, pageSize, sortingInfo);
		}
	};

	const handleSectorChange = (value: string) => {
		setLoading(true);
		setSectorName(value);
		sectorTagUpdatefun(value);
	};

	const sectorTagUpdatefun = (sector: string) => {
		if (sector != 'all') {
			if (sector == 'Blank')
				sector = '';

			const isInDatapipeline = allSectorOptionsList?.datapipeline.some(item => item.sector === sector);
			const isInUptime = allSectorOptionsList?.uptime.some(item => item.sector === sector);
			const filteredData = {
				datapipeline: isInDatapipeline || false,
				uptime: isInUptime || false
			};
			setSectorTagList(filteredData);
			getDataProcessingSummary(filterMonth, sector, 'sector');
			if (isInUptime)
				getDataProcessingSynapseTime(filterMonth, sector, 'sector');
		} else {
			const filteredData = {
				datapipeline: true,
				uptime: true
			};
			setSectorTagList(filteredData);
			getDataProcessingSummary(filterMonth, sector, 'sector');
			getDataProcessingSynapseTime(filterMonth, sector, 'sector');
		}
	}

	const adfPipelineNumber = sectorTagList?.datapipeline
		? ADFPipeline
			? formatNumber((ADFPipeline / 1000).toFixed(2).toString())
			: '-'
		: formatNumber((allSectorADFPipelineData / 1000).toFixed(2).toString());

	const adfPipelineUnits =
		!sectorTagList?.datapipeline && allSectorADFPipelineData ? 'k' : ADFPipeline ? 'k' : '';

	const adfPipelineSectorLabel = sectorTagList?.datapipeline
		? sectorName === 'all'
			? ''
			: sectorName
		: '';

	return (
		<PageWrapper>
			<PageHeader title="Data Processing Summary" icon={DataProcIcon} lastSync={teradataStorageLastSyncDate} />
			<Grid container spacing={2} p={{ xs: 1, md: 2 }} mt={1}>
				{/* Top Row: Data Processing (Left, 8 cols) & Compute Clusters (Right, 4 cols) */}
				<Grid item xs={12} lg={8}>
					<WidgetCardContainer
						bgColor="#E4EDFF"
						title="Data Processing"
						titleSx={{ fontSize: '20px', fontWeight: 600, color: '#001E3E' }}
						sx={{ borderRadius: '16px', border: '1px solid #CCE0FF', p: 2.5, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)' }}
					>
						<Grid container spacing={2}>
							<Grid item xs={12} md={6} id="adf-pipelines">
								<NumberWidget
									title={<HighlightedText text="ADF Pipelines" />}
									tooltipLabel="Total ADF Pipelines in D&AI"
									renderTooltip={(label: string) => renderTooltipIcon(label, 'light')}
									hasTooltip={true}
									number={adfPipelineNumber}
									units={adfPipelineUnits}
									bgColor="#FFFFFF"
									color="#001E3E"
									valueFontWeight={700}
									valueFontSize="28px"
									sameDecimalSize={true}
									isLoading={ADFPipeline ? ADFPipeline.toString() === '-' : false}
									handleEvent={isEnvTypePROD ? undefined : () => handleClick('ADF')}
									sectorLabel={adfPipelineSectorLabel}
								/>
							</Grid>

							<Grid item xs={12} md={6} id="teradata-jobs">
								<NumberWidget
									title={<HighlightedText text="Teradata Jobs" />}
									tooltipLabel="Total Teradata Jobs"
									renderTooltip={(label: string) => renderTooltipIcon(label, 'light')}
									hasTooltip={true}
									number={teradataJobs ? formatNumber((teradataJobs / 1000).toFixed(2).toString()) : ''}
									units={teradataJobs ? 'k' : ''}
									bgColor="#FFFFFF"
									color="#001E3E"
									valueFontWeight={700}
									valueFontSize="28px"
									sameDecimalSize={true}
									isLoading={teradataJobs?.toString() === '-'}
									handleEvent={isEnvTypePROD ? undefined : () => handleClick('Teradata')}
								/>
							</Grid>

							<Grid item xs={12} md={6} id="azure-pipeline-trend">
								<ChartWidget
									title={<HighlightedText text="ADF Pipeline Trend" />}
									tooltipLabel="ADF Pipeline monthly trend over time"
									data={pipelineGrowthOptions}
									isLoading={pipelineGrowthLoading}
									lastUpdatedDate={lastUpdatedDatePipeline}
									themeMode="lightTrend"
									chartBgColor="#FFFFFF"
									titleColor="#001E3E"
									isDataEstateTrend={true}
									sectorLabel={sectorTagList?.datapipeline ? (sectorName == 'all' ? '' : sectorName) : ''}
								/>
							</Grid>

							<Grid item xs={12} md={6} id="teradata-job-trend">
								<ChartWidget
									title={<HighlightedText text="Teradata Job Trend" />}
									tooltipLabel="Teradata Job monthly trend over time"
									data={teradataJobsOptions}
									isLoading={teradataJobsLoading}
									lastUpdatedDate={lastUpdatedDateTeradata}
									themeMode="lightTrend"
									chartBgColor="#FFFFFF"
									titleColor="#001E3E"
									isDataEstateTrend={true}
								/>
							</Grid>
						</Grid>
					</WidgetCardContainer>
				</Grid>

				<Grid item xs={12} lg={4}>
					<WidgetCardContainer
						bgColor="#E4EDFF"
						title="Compute Clusters"
						titleSx={{ fontSize: '20px', fontWeight: 600, color: '#001E3E' }}
						sx={{ borderRadius: '16px', border: '1px solid #CCE0FF', p: 2.5, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)' }}
					>
						<Grid container spacing={2}>
							<Grid item xs={12} id="databricks">
								<NumberWidget
									title={<HighlightedText text="Databricks" />}
									tooltipLabel="Total Databricks compute clusters"
									renderTooltip={(label: string) => renderTooltipIcon(label, 'light')}
									hasTooltip={true}
									number={databricksClusters ? formatNumber(databricksClusters) : 0}
									units={databricksClusters ? 'MM' : ''}
									bgColor="#FFFFFF"
									color="#001E3E"
									valueFontWeight={700}
									valueFontSize="28px"
									sameDecimalSize={true}
									isLoading={databricksClusters?.toString() === '-'}
									handleEvent={isEnvTypePROD ? undefined : () => handleClick('dataBricks')}
								/>
							</Grid>

							<Grid item xs={12} id="databricks-trend">
								<ChartWidget
									title={<HighlightedText text="Databricks Trend" />}
									tooltipLabel="Databricks compute clusters monthly trend over time"
									data={clusterGrowthOptions}
									isLoading={clusterGrowthLoading}
									lastUpdatedDate={lastUpdatedDateCluster}
									restrictToMillions={true}
									isDatabrick={true}
									themeMode="lightTrend"
									chartBgColor="#FFFFFF"
									titleColor="#001E3E"
									isDataEstateTrend={true}
								/>
							</Grid>
						</Grid>
					</WidgetCardContainer>
				</Grid>
			</Grid>

			{/* Bottom Row: Performance (Left, 7 cols) & Reliability (Right, 5 cols) */}
			<Grid container spacing={2} p={{ xs: 1, md: 2 }} mt={0}>
				<Grid item xs={12} lg={7}>
					<WidgetCardContainer
						bgColor="#E4EDFF"
						title="Performance"
						titleSx={{ fontSize: '20px', fontWeight: 600, color: '#001E3E' }}
						sx={{ borderRadius: '16px', border: '1px solid #CCE0FF', p: 2.5, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)' }}
					>
						<Grid container spacing={2}>
							<Grid item xs={12} md={6} id="dbx-exec-time">
								<MultiLineWidget
									title={
										<Stack direction="row" alignItems="center" gap={1}>
											<HighlightedText text="Databricks Job Execution Time" />
											{renderTooltipIcon('Databricks Job Execution Time across cluster categories', 'light')}
										</Stack>
									}
									isLoading={performanceDBJobExecutionTimeLoader}
									data={performanceDBJobExecutionTimeChartOptions}
									containerColor="#FFFFFF"
									titleColor="#001E3E"
								/>
							</Grid>
							<Grid item xs={12} md={6} id="td-exec-time">
								<MultiLineWidget
									title={
										<Stack direction="row" alignItems="center" gap={1}>
											<HighlightedText text="Teradata Job Execution Time" />
											{renderTooltipIcon('Teradata Job Execution Time across schedulers', 'light')}
										</Stack>
									}
									isLoading={teradataJobExecutionTimeLoader}
									data={teradataJobExecutionTimeChartOptions}
									containerColor="#FFFFFF"
									titleColor="#001E3E"
								/>
							</Grid>
						</Grid>
					</WidgetCardContainer>
				</Grid>

				<Grid item xs={12} lg={5}>
					<WidgetCardContainer
						bgColor="#E4EDFF"
						title="Reliability"
						titleSx={{ fontSize: '20px', fontWeight: 600, color: '#001E3E' }}
						sx={{ borderRadius: '16px', border: '1px solid #CCE0FF', p: 2.5, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)' }}
					>
						<Grid container spacing={2}>
							<Grid item xs={12} md={6} id="azuresql-uptime">
								<GuageWidget
									title={
										<Stack direction="row" alignItems="center" gap={1}>
											<HighlightedText text="Azure SQL Uptime" />
											{renderTooltipIcon('Azure SQL Database Service Uptime percentage', 'light')}
										</Stack>
									}
									isLoading={azureUptimeLoader}
									data={azureSqlUptime}
								/>
							</Grid>
							<Grid item xs={12} md={6} id="synapse-uptime">
								<GuageWidget
									title={
										<Stack direction="row" alignItems="center" gap={1}>
											<HighlightedText text="Synapse Uptime" />
											{renderTooltipIcon('Azure Synapse Analytics Service Uptime percentage', 'light')}
										</Stack>
									}
									isLoading={synapseUptimeLoader}
									data={synapseUptime}
									sectorLabel={sectorTagList?.uptime == true ? (sectorName == 'all' ? '' : sectorName) : ''}
								/>
							</Grid>
						</Grid>
					</WidgetCardContainer>
				</Grid>

				{/* Drill-down Table Section */}
				{isTableVisible && (
					<Grid item xs={12} mt={1}>
						<WidgetCardContainer
							bgColor="#E4EDFF"
							title={tableHeading}
							titleSx={{ fontSize: '20px', fontWeight: 600, color: '#001E3E' }}
							sx={{ borderRadius: '16px', border: '1px solid #CCE0FF', p: 2.5, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)' }}
						>
							<Grid item xs={12}>
								{tableData && tableData.length > 0 ? (
									<CustomizedDataGrid
										tableColumns={getColumns()}
										tableData={tableData}
										tableType="sector"
										defaultColumnNames={defaultColumnNames}
										onSorting={handleSorting}
										currSorting={sortingInfo}
										page={page}
										pageSize={pageSize}
										paginationData={paginationData}
										listLength={tableData.length}
										handlepageSizeChange={handlepageSizeChange}
										handlePageChange={handlePageChange}
										isDateRangeFilter={false}
										isDisabled={false}
										isFetching={true}
									/>
								) : (
									<span style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>No records found</span>
								)}
							</Grid>
						</WidgetCardContainer>
					</Grid>
				)}
			</Grid>
		</PageWrapper>
	);
}
